export default "__VITE_ASSET__LfRcu9GW__"